import Link from 'next/link';

import { cx } from '@/shared/lib/cx';
import type { AppHref } from '@/shared/lib/route';

import styles from './breadcrumbs.module.scss';

/** `muted` keeps a link in the caption colour (07B "Личный кабинет" inside the profile trail). */
export type BreadcrumbItem = { label: string; href?: AppHref | undefined; muted?: boolean };

export function Breadcrumbs({
  items,
  className,
}: {
  items: readonly BreadcrumbItem[];
  className?: string | undefined;
}) {
  return (
    <nav aria-label="Хлебные крошки" className={cx(styles.root, className)}>
      <ol className={styles.list}>
        {items.map((item, index) => {
          const last = index === items.length - 1;
          return (
            <li key={item.label} className={styles.item}>
              {item.href && !last ? (
                <Link href={item.href} className={styles.link} data-muted={item.muted || undefined}>
                  {item.label}
                </Link>
              ) : (
                <span
                  aria-current={last ? 'page' : undefined}
                  className={last ? styles.current : undefined}
                >
                  {item.label}
                </span>
              )}
              {!last && (
                <span aria-hidden="true" className={styles.separator}>
                  /
                </span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
